import React, { useEffect, useState } from 'react';
import Tabs from '@showclix-shared/Tabs';
import { useTranslation } from '@c/Translations';

const lgBreakpoint = 960;

export const DynamicPageContent = (props) => {
    const { t } = useTranslation();

    const [windowWidth, setWindowWidth] = useState(0);

    const TABS_LABELS = {
        tickets: t('checkout__tickets'),
        eventInfo: t('checkout__event_info'),
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        }

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (windowWidth >= lgBreakpoint) {
        return (
             <div className='dynamic-page-content'>
                <div>{props.children.filter(child => child?.props?.tabEventInfo || (!child?.props?.tabTickets && !child?.props?.tabEventInfo))}</div>
                <div>
                    <div className="page-content__outer">
                        <div className="page-content__inner">{props.children?.filter(child => child?.props?.tabTickets)}</div>
                    </div>
                </div>
             </div>
        );
    }

    return (
        <div className='dynamic-page-content'>
            {props.children.filter(child => !child?.props?.tabTickets && !child?.props?.tabEventInfo)}
            <Tabs openToTab={TABS_LABELS.tickets}>
                <div label={TABS_LABELS.tickets} title={TABS_LABELS.tickets}>{props.children?.filter(child => child?.props?.tabTickets)}</div>
                <div label={TABS_LABELS.eventInfo} title={TABS_LABELS.eventInfo}>{props.children?.filter(child => child?.props?.tabEventInfo)}</div>
            </Tabs>
        </div>
    )
};
